var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-t"},[_vm._m(0),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$route.meta.title))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":"//i0cloud.jrjimg.cn/cloud/images/common/logo.png","alt":""}})])
}]

export { render, staticRenderFns }